import _ from 'lodash';
import Vue from 'vue';
import M from 'moment';
import * as VueGoogleMaps from 'vue2-google-maps';
import Notifications from 'vue-notification';
// import Vue2TouchEvents from 'vue2-touch-events'
// import { Pagination } from 'bootstrap-vue';

import bootstrapdatetimepicker from 'bootstrap-datetimepicker-npm';

// import main from './store/main';
import getHelpers from './helpers';

if (!window.libs) {
    window._72_libs = {};
}

window.exportLib = (key, value) => {
    window._72_libs[key] = value;
}

window.importLib = (key) => {
    return window._72_libs[key];
}

// Vue.use(Vuex);
// Vue.use(Vue2TouchEvents);
Vue.use(Notifications);
// Vue.use(Pagination);
Vue.use(VueGoogleMaps, {
    load: {
        key: window.env.GOOGLE_MAP_KEY,
        libraries: "places" // necessary for places input
    }
});

// var store = new Vuex.Store(main);
// window.store = store;
window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        new Vue({
            el: root,
            // store,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.exportLib('lodash', _);
window.exportLib('moment', M);
// window.exportLib('Vuex', Vuex);
window.exportLib('getHelpers', getHelpers);
// window.dispatchEvent(new Event('vue-init'));

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.getAttribute('data-src');
    })
    .value();
